import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import toast from 'react-hot-toast';

interface URLInputProps {
  onAddUrl: (url: string) => void;
  /** 占位文本 */
  placeholder?: string;
  /** 按钮文本 */
  buttonText?: string;
  /** 是否自动验证URL格式 */
  validateUrl?: boolean;
  /** 自定义验证函数，返回错误消息，无错误返回null */
  customValidate?: (url: string) => string | null;
  /** 无效URL消息 */
  invalidUrlMessage?: string;
  /** 空URL消息 */
  emptyUrlMessage?: string;
}

export const URLInput: React.FC<URLInputProps> = ({ 
  onAddUrl,
  placeholder = "请输入网页 URL，以 http:// 或 https:// 开头",
  buttonText = "添加 URL",
  validateUrl = true,
  customValidate,
  invalidUrlMessage = "请输入有效的 URL，需以 http:// 或 https:// 开头",
  emptyUrlMessage = "请输入有效的 URL"
}) => {
  const [inputUrl, setInputUrl] = useState('');

  const handleAddUrl = () => {
    if (!inputUrl.trim()) {
      toast.error(emptyUrlMessage);
      return;
    }

    // 优先使用自定义验证
    if (customValidate) {
      const errorMessage = customValidate(inputUrl);
      if (errorMessage) {
        toast.error(errorMessage);
        return;
      }
    } else if (validateUrl && !inputUrl.startsWith('http://') && !inputUrl.startsWith('https://')) {
      toast.error(invalidUrlMessage);
      return;
    }

    onAddUrl(inputUrl);
    setInputUrl('');
  };

  return (
    <div className="flex items-center mb-4">
      <div className="relative group flex-grow focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-background focus-within:ring-opacity-50 rounded-md">
        <Input
          type="url"
          value={inputUrl}
          className="pr-24 border-r-0 focus-visible:ring-0 focus-visible:ring-offset-0 rounded-r-none"
          placeholder={placeholder}
          spellCheck={false}
          onChange={(e) => setInputUrl(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleAddUrl();
            }
          }}
        />
        <Button
          onClick={handleAddUrl}
          className="absolute right-0 top-0 h-full group-focus-within:rounded-none rounded-l-none border-l-0 transition-colors"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}; 